import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { StorageService } from '../services/storage/storage.service';
import { isInternalApi, isPublicApi } from '@shared/utils/utils';

export const authJwtInterceptor: HttpInterceptorFn = (request, next) => {
  const storageService = inject(StorageService);

  if (isInternalApi(request.url) && !isPublicApi(request.url)) {
    if (storageService.getAuthToken()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${storageService.getAuthToken()}`,
        },
      });
    }
  }

  return next(request);
};
